import { FixedNationwidePricingContextProvider, FixedPricingContextProvider } from "@/components/organisms";
import { Nationwide } from "./Nationwide";
import { PricingLocation } from "./PricingLocation";
import { PricingState } from "./PricingState";
import { PricingProfilePanel } from "@/components/organisms/TripCost/FixedPricing/PricingProfilePanel";

export const PricingProfile = () => {
  return (
    <FixedPricingContextProvider>
      <FixedNationwidePricingContextProvider>
        <PricingProfilePanel />
      </FixedNationwidePricingContextProvider>
    </FixedPricingContextProvider>
  );
};

PricingProfile.Nationwide = Nationwide;
PricingProfile.PricingState = PricingState;
PricingProfile.PricingLocation = PricingLocation;
